import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import swal from 'sweetalert2'
import Preloader from '../preloader/Preloader'
import $ from 'jquery'

//components
import { DataTableItem, UserRoute, BreadCrumb, Card } from 'src/components'

//services
import { getOrderTypes, deleteOrderTypes } from 'src/services'

const OrderTypes = () => {
  const [loading, setLoading] = useState(true)
  const [orderTypes, setOrderTypes] = useState([])

  useEffect(() => {
    getOrderTypes()
      .then((res) => {
        if (res.data.status === 200) {
          setOrderTypes(res.data.order_types)
        }
        setTimeout(() => {
          $('#dataTable').DataTable({
            scrollX: false,
            pageLength: 100,
          })
        }, 10)
        setLoading(false)
      })
      .catch(() => {
        setTimeout(() => {
          $('#dataTable').DataTable({
            scrollX: false,
            pageLength: 100,
          })
        }, 10)
        setLoading(false)
      })
  }, [])

  const deleteRecord = (e, id) => {
    e.preventDefault()

    const thisClicked = e.currentTarget

    swal
      .fire({
        title: 'Are you sure you want to proceed?',
        text: 'This will completely delete the Order Type permanently',
        icon: 'warning',
        showDenyButton: true,
        denyButtonText: 'Cancel!',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Proceed!',
      })
      .then((result) => {
        if (result.isConfirmed) {
          deleteOrderTypes(id)
            .then((res) => {
              if (res.data.status === 200) {
                swal.fire('Deleted!', res.data.message, 'success')
                thisClicked.closest('tr').remove()
              } else if (res.data.status === 404) {
                swal.fire('Error', res.data.message, 'error')
              }
            })
            .catch(() => {
              setTimeout(() => {
                $('#dataTable').DataTable({
                  scrollX: false,
                  pageLength: 100,
                })
              }, 10)
              setLoading(false)
            })
        } else if (result.isDenied) {
          swal.fire('Changes are not saved', '', 'info')
        }
      })
  }

  const renderRowActions = (item) => {
    return (
      <>
        <Link to={`/order_types/update/${item.id}`} className="btn btn-info me-2">
          Edit
        </Link>
        <button onClick={(e) => deleteRecord(e, item.id)} className="btn btn-danger">
          Delete
        </button>
      </>
    )
  }

  const columns = [
    { label: 'Name', key: 'name' },
    // ... other columns
  ]

  const title = 'Order Types'

  const breadcrumb = [
    {
      title: title,
      name: 'Add Order Type',
      subtitle: '',
      subtitleroute: '',
    },
  ]

  const buttonValues = [
    {
      title: 'Add Order Type',
      variants: 'btn btn-primary my-3 mr-2',
      routes: '/order_types/create',
    },
  ]

  const cardValues = [
    {
      title: title,
    },
  ]
  return (
    <div>
      <BreadCrumb data={breadcrumb} />
      <UserRoute data={buttonValues} />

      <Card data={cardValues}>
        {<DataTableItem data={orderTypes} columns={columns} renderRowActions={renderRowActions} />}
      </Card>
    </div>
  )
}

export default OrderTypes
